<template>
  <div id="shandian">
    <div class="app-header">
      <div class="app-header-nav-wrapper">
        <div class="app-header-nav">
          <img class="app-header-logo" src="../assets/logo.png" width="100" />
          <div
            style="
              padding: 5px 10px;
              font-size: 12px;
              position: absolute;
              right: 20px;
              top: 17px;
            "
            class="app-header-button app-button plain"
            @click="goRouter('home')"
          >
            了解闪电签
          </div>
          <div class="layout-aic app-header-nav-box">
            <ul class="app-header-nav-list">
              <liindex
                v-for="item in navList"
                :key="item.name"
                :class="{ active: item.name == activeNav }"
                @click="goRefs(item.name)"
                class="app-header-nav-item"
              >
                {{ item.text }}
              </liindex>
            </ul>
            <div class="app-button" @click="show_form_dialog = true">
              立即体验
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-banner-wrapper" ref="index">
      <div class="home-banner">
        <div class="home-banner-item">
          <div class="home-banner1">
            <div class="home-banner1-content">
              <h1>闪店<br />旅行社自己的微商城</h1>
              <p>——专业的旅游业移动互联网解决方案提供商</p>
              <div class="banner-button" @click="show_form_dialog = true">
                立即咨询
              </div>
            </div>
            <img
              class="home-banner1-pic"
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/phone.png"
              alt="闪店，旅行社自己的微商城！"
            />
          </div>
        </div>
        <div class="home-banner-mobile">
          <img
            src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/banner2.jpg"
            width="100%"
            alt="闪店，旅行社自己的微商城"
          />
          <div
            class="app-button app-button--blue"
            @click="show_form_dialog = true"
          >
            立即咨询
          </div>
        </div>
      </div>
      <div class="home-arrow-line home-arrow-line--banner">
        <span class="home-arrow-line-left"></span>
        <span class="home-arrow-line-right"></span>
      </div>
    </div>
    <div class="home-main">
      <div class="home-main-part-one">
        <h1 class="home-main-title">社交流量一网打进</h1>
        <p class="home-main-sub-title">
          微信生态无缝渗入，抖音，QQ，微博，头条同步兼容
        </p>
        <ul class="home-main-spread">
          <li class="home-main-spread-item">
            <img
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/spread-wx.jpg"
            />
            <h2>微信生态传播</h2>
            <p>小程序一键分享，直接触达微信好友/微信群。</p>
          </li>
          <li class="home-main-spread-item">
            <img
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/spread-qr.jpg"
            />
            <h2>二维码传播</h2>
            <p>
              带参数二维码，随时随地贴码分享，朋友圈，公众号、微博、头条号等多渠道分享。
            </p>
          </li>
          <li class="home-main-spread-item">
            <img
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/spread-retail.jpg"
            />
            <h2>分销传播</h2>
            <p>
              B端可选择性分销设置，支持公司分部，挂靠单位
              ，门店，同业等分销自由定价，实现小b类的传播分享。
            </p>
          </li>
          <li class="home-main-spread-item">
            <img
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/spread-share.jpg"
            />
            <h2>营销传播</h2>
            <p>结合营销工具助力砍价，转发抽奖，拼团等，实现裂变传播。</p>
          </li>
        </ul>
      </div>
      <div class="home-main-part-two">
        <img
          width="854"
          src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/hexingongneng.jpg"
        />
        <div class="app-shandian-button">核心功能</div>
      </div>
      <div class="home-main-part-three">
        <h1 class="home-main-title">强大的旅游业电商系统</h1>
        <p class="home-main-sub-title">铺货，交易，营销，数据等全方位支持</p>
      </div>
    </div>

    <div class="e-commerce-swipe">
      <p class="e-commerce-item">商城</p>
      <div class="swiper-item-wrapper gray">
        <div class="swiper-item">
          <ul class="e-commerce-intro">
            <li class="e-commerce-intro-item">
              <h2>签证全品类</h2>
              <p>全球签证种类，全领区，全人群的资料模板覆盖，一键铺货。</p>
            </li>
            <li class="e-commerce-intro-item">
              <h2>产品页面个性化</h2>
              <p>
                商品页面信息：签证说明，套餐定价，资料要求，护照上传识别，整页直观展现，支持模块自定义。
              </p>
            </li>
            <li class="e-commerce-intro-item">
              <h2>店铺装修自定义</h2>
              <p>
                支持店首专题+产品多样化分类自定义展示，玩转个性化视觉及排版设计。
              </p>
            </li>
            <li class="e-commerce-intro-item">
              <h2>不依托平台</h2>
              <p>
                商家自己的小程序商城，不依托任何平台。店铺基础信息自定义，名称、联系方式、LOGO、店铺简介等支持自定义，小程序独享商家自有品牌。
              </p>
            </li>
          </ul>
          <img
            class="pic"
            src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/e-shop.png"
            alt="商城"
            width="370"
          />
        </div>
      </div>
      <p class="e-commerce-item">营销</p>
      <div class="swiper-item-wrapper">
        <div class="swiper-item">
          <img
            class="pic"
            src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/marketing.png"
            alt="营销"
            width="370"
          />
          <ul class="e-commerce-intro">
            <li class="e-commerce-intro-item">
              <h2>营销工具多样化</h2>
              <p>优惠券、会员积分制、拼团、秒杀、出签助力加急</p>
            </li>
            <li class="e-commerce-intro-item">
              <h2>营销参数自定义</h2>
              <p>
                优惠券面额及目标客户的自定义下发，或客户自主领取等模式自由切换
              </p>
            </li>
            <li class="e-commerce-intro-item">
              <h2>精准营销</h2>
              <p>
                根据客户标签实现精准营销，Eg：办理单次日签客户，针对性的进行日本线路推送。
              </p>
            </li>
          </ul>
        </div>
      </div>
      <p class="e-commerce-item">数据</p>
      <div class="swiper-item-wrapper gray">
        <div class="swiper-item">
          <ul class="e-commerce-intro">
            <li class="e-commerce-intro-item">
              <h2>运营数据</h2>
              <p>交易订单数据，访客路径，流量，扫码统计，商品分析等</p>
            </li>
            <li class="e-commerce-intro-item">
              <h2>财务数据</h2>
              <p>销售额分析，客服绩效分析，分销商销售额分析</p>
            </li>
            <li class="e-commerce-intro-item">
              <h2>客户数据分析</h2>
              <p>客户年龄，性别，消费类型，消费习惯等数据分析</p>
            </li>
          </ul>
          <img
            class="pic"
            src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/data.png"
            alt="数据"
            width="370"
          />
        </div>
      </div>
      <p class="e-commerce-item">交易</p>
      <div class="swiper-item-wrapper">
        <div class="swiper-item">
          <img
            class="pic"
            src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/business.png"
            alt="交易"
            width="370"
          />
          <ul class="e-commerce-intro">
            <li class="e-commerce-intro-item">
              <h2>咨询</h2>
              <p>
                微信在线实时咨询，满足微信群体沟通习惯。直接跳转电话拨号咨询，快速高效。
              </p>
            </li>
            <li class="e-commerce-intro-item">
              <h2>支付</h2>
              <p>
                在线支付下单：微信支付，银行卡提现。实时交易无账期，随时提现。
              </p>
            </li>
            <li class="e-commerce-intro-item">
              <h2>多样化售后场景</h2>
              <p>
                支持改价，取消，退款申请等售后订单处理，满足签证交易多样化场景。
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <footer class="footer">
      <h1 class="home-main-title">化客户为粉丝</h1>
      <p class="home-main-sub-title">
        积分商城，旅游业周边服务等完美覆盖并精准推送
      </p>
      <ul class="footer-function">
        <li class="footer-function-item">
          <span class="logo"
            ><img
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/genzong.png"
              alt="办签实时跟踪"
          /></span>
          <h3>办签实时跟踪</h3>
          <p>出签状态，护照状态实时可查询，提高用户办签体验</p>
        </li>
        <li class="footer-function-item">
          <span class="logo"
            ><img
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/gongju.png"
              alt="出境游实用工具"
          /></span>
          <h3>出境游实用工具</h3>
          <p style="text-align: left">
            资产冻结证明：在线办理资产冻结证明，无需跑银行，无需取号排队。<br /><br />汇率查询：商城内实现汇率便捷查询。
          </p>
        </li>
        <li class="footer-function-item">
          <span class="logo"
            ><img
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/biaoqian.png"
              alt="客户标签化"
          /></span>
          <h3>客户标签化</h3>
          <p>客户打标，助力客户深度画像，实现后期精准化广告推送。</p>
        </li>
      </ul>
      <div class="footer-intro">
        <p class="footer-intro-text">专业的旅游业移动电商解决方案提供商</p>
        <p class="footer-intro-button" @click="show_form_dialog = true">
          立即咨询
        </p>
        <p class="footer-intro-tel">0571-87670963</p>
      </div>
    </footer>

    <transition name="fade">
      <div class="home-contact-wrapper" v-show="show_form_dialog">
        <div class="home-contact-mask" @click="show_form_dialog = false"></div>
        <div class="home-contact" ref="contact">
          <div class="home-contact-content">
            <div class="home-contact-item home-contact-item--left">
              <h2>填写并提交表单，我们将尽快与您取得联系</h2>
              <p class="error-text">{{ errorText }}</p>
              <div class="home-contact-form">
                <div class="app-form-item">
                  <input
                    v-model="teamName"
                    placeholder="公司名称"
                    type="text"
                  />
                </div>
                <div
                  class="app-form-item app-form-item--select city-select-form-item"
                  @click.stop="show_city_select = true"
                >
                  <input
                    style="pointer-events: none"
                    :value="cityValue"
                    placeholder="所在城市"
                    type="text"
                  />
                  <div class="city-select" v-show="show_city_select">
                    <ul class="city-select-list province">
                      <li
                        class="city-select-item"
                        :class="{ active: currentProvinceName == item.name }"
                        v-for="item in province"
                        :key="item.id"
                        @click.stop="
                          ;(currentProvinceName = item.name),
                            (currentCityName = '')
                        "
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                    <ul class="city-select-list city" v-if="citys.length">
                      <li
                        class="city-select-item"
                        :class="{ active: currentCityName == item.name }"
                        v-for="item in citys"
                        :key="item.id"
                        @click.stop="
                          ;(currentCityName = item.name),
                            (show_city_select = false)
                        "
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="app-form-item">
                  <input
                    v-model="contacts"
                    placeholder="联系人姓名"
                    type="text"
                  />
                </div>
                <div class="app-form-item">
                  <input
                    v-model="mobile"
                    placeholder="联系人手机号"
                    type="tel"
                  />
                </div>
              </div>
              <div class="layout-jcfe home-contact-form-submit-button">
                <div style="width: 160px" class="app-button" @click="submit">
                  {{ confirmText }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import province from '@/data/province'
import axios from 'axios'
export default {
  name: 'home',
  data() {
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      show_form_dialog: false,
      activeIndex: 0,
      province: province,
      currentProvinceName: '',
      currentCityName: '',
      teamName: '',
      contacts: '',
      mobile: '',
      errorText: '',
      show_city_select: false,
      scrollEnding: true,
      indexTop: 0,
      introTop: '',
      partnerTop: '',
      contactTop: '',
      interval: 0,
      confirmText: '提交',
      activeNav: 'index',
      navList: [
        {
          text: '首页',
          name: 'index',
        },
        {
          text: '联系我们',
          name: 'contact',
        },
        {
          text: '办签工具',
          name: 'home',
        },
      ],
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    cityValue() {
      if (!this.currentProvinceName && !this.currentCityName) {
        return ''
      } else {
        return this.currentProvinceName + ' / ' + this.currentCityName
      }
    },
    citys() {
      let province = this.province.filter(
        (item) => item.name == this.currentProvinceName
      )
      if (province.length) {
        return province[0].children
      }
      return []
    },
  },
  mounted() {
    document.addEventListener('click', () => {
      this.show_city_select = false
    })
  },
  methods: {
    goRouter(name) {
      this.$router.push({
        name: name,
      })
    },
    handleSlideChange() {
      this.activeIndex = this.swiper.activeIndex
      console.log(this.swiper.activeIndex)
    },
    slideTo(num) {
      this.swiper.slideTo(num, 500, false)
    },
    getScrollTop() {
      return document.documentElement.scrollTop || document.body.scrollTop
    },
    getClientHeight() {
      return document.documentElement.clientHeight || document.body.clientHeight
    },
    getScrollHeight() {
      return document.documentElement.scrollHeight || document.body.scrollHeight
    },
    setRefsScrollTop() {
      this.introTop = Math.floor(
        this.$refs.intro.getBoundingClientRect().top + this.getScrollTop() - 74
      )
      this.partnerTop = Math.floor(
        this.$refs.partner.getBoundingClientRect().top +
          this.getScrollTop() -
          74
      )
      this.contactTop = Math.floor(
        this.$refs.contact.getBoundingClientRect().top +
          this.getScrollTop() -
          74
      )
    },
    scrollHandle(top) {
      if (!this.scrollEnding) return
      if (top - this.getScrollTop() > 0) {
        this.scrollEnding = false
        this.scrollAnim(top, 'plus')
      } else if (top - this.getScrollTop() < 0) {
        this.scrollEnding = false
        this.scrollAnim(top, 'minus')
      }
    },
    scrollAnim(top, type) {
      if (type == 'plus' && top - this.getScrollTop() > 0) {
        if (top - this.getScrollTop() < 1) {
          this.scrollEnding = true
          return
        }
        requestAnimationFrame(() => {
          if (
            this.getScrollTop() + this.getClientHeight() >
            this.getScrollHeight() - 1
          ) {
            this.scrollEnding = true
            return
          }
          let diff = Math.floor((top - this.getScrollTop()) / 6)
          if (diff < 1) {
            console.log(this.getScrollTop())
            window.scrollTo(0, this.getScrollTop() + 1)
            console.log(this.getScrollTop())
            this.scrollAnim(top, type)
          } else {
            // console.log(this.getScrollTop())
            window.scrollTo(0, this.getScrollTop() + diff)
            // console.log(this.getScrollTop())
            this.scrollAnim(top, type)
          }
        })
      } else if (type == 'minus' && top - this.getScrollTop() < 0) {
        if (top - this.getScrollTop() > -1) {
          this.scrollEnding = true
          return
        }
        requestAnimationFrame(() => {
          let diff = (top - this.getScrollTop()) / 8
          if (diff > -1) {
            window.scrollTo(0, this.getScrollTop() - 1)
            this.scrollAnim(top, type)
          } else {
            window.scrollTo(0, this.getScrollTop() + diff)
            this.scrollAnim(top, type)
          }
        })
      } else {
        this.scrollEnding = true
        this.interval = 0
      }
    },
    goRefs(name) {
      if (name == 'home') {
        this.$router.push({
          name: 'home',
        })
        return
      }
      if (name == 'contact') {
        this.show_form_dialog = true
      }
    },
    submit() {
      if (this.teamName === '') {
        this.errorText = '请输入公司名称'
        return
      }
      if (this.teamName.length < 2 || this.teamName.length > 64) {
        this.errorText = '公司名称长度为2-64个字'
        return
      }
      if (this.currentProvinceName === '' || this.currentCityName === '') {
        this.errorText = '请选择城市'
        return
      }
      if (this.contacts === '') {
        this.errorText = '请输入联系人姓名'
        return
      }
      if (this.mobile === '') {
        this.errorText = '请输入手机号'
        return
      }
      if (!/^(\+86([\s-])?)?1\d{10}$/.test(this.mobile)) {
        this.errorText = '请输入正确的手机号'
        return
      }
      this.errorText = ''
      this.confirmText = '正在提交...'
      axios({
        method: 'post',
        url: 'https://visasapi.visaai.com/homepage/apply/submit',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          city: this.currentCityName,
          contacts: this.contacts,
          mobile: this.mobile,
          province: this.currentProvinceName,
          teamName: this.teamName,
        },
      })
        .then((response) => {
          // handle success
          this.confirmText = '提交'
          if (response.data.code === 0) {
            this.$message({
              text: '您的信息已经提交成功',
              type: 'success',
              time: 5000,
            })
            this.currentCityName = ''
            this.contacts = ''
            this.mobile = ''
            this.currentProvinceName = ''
            this.teamName = ''
            this.show_form_dialog = false
          } else {
            this.$message({
              text: response.data.msg,
              type: 'error',
            })
          }
        })
        .catch((error) => {
          // handle error
          this.$message({
            text: '请求提交接口失败',
            type: 'error',
          })
          this.confirmText = '提交'
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">
@import '../scss/variables';
@import '../scss/reset';
#shandian {
  height: 100%;
  width: 100%;
  overflow: auto;
  position: absolute;
  left: 0;
  top: 0;
  .app-header-banner {
    margin-top: 74px;
  }
  .app-header-nav-list {
    display: flex;
  }
  .app-header-button {
    display: none;
  }
  .app-header-nav-item {
    padding: 0 15px;
    line-height: 20px;
    position: relative;
    cursor: pointer;
    color: $font-color-primary;
    transition: ease all 0.3s;
    &:hover {
      color: $green;
    }
    &.active {
      color: $green;
      &:after {
        content: '';
        position: absolute;
        bottom: -7px;
        left: 13px;
        right: 13px;
        height: 4px;
        background-color: $green;
      }
    }
  }
  .home-banner-wrapper {
    margin-top: 74px;
    background: url('https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/banner-bg%403x.jpg?x-oss-process=image/resize,w_1920')
      no-repeat center center;
    background-size: cover;
  }
  .home-banner {
    max-width: 1000px;
    margin: 0 auto;
    height: 534px;
    overflow: hidden;
  }
  .home-banner-item {
    height: 534px;
    display: flex;
    align-items: center;
    position: relative;
  }
  .home-banner-mobile {
    display: none;
  }
  .home-banner1 {
    h1 {
      font-size: 46px;
      font-weight: normal;
      color: #fff;
      padding-bottom: 23px;
    }
    p {
      color: rgba(255, 255, 255, 0.8);
      font-size: 22px;
      font-weight: 300;
      line-height: 35px;
    }
    .banner-button {
      cursor: pointer;
      font-size: 18px;
      margin-top: 43px;
      border: 1px solid #fff;
      border-radius: 20px;
      padding: 7px 44px;
      color: #fff;
      display: inline-block;
    }
  }
  .home-banner1-content {
    position: relative;
    z-index: 2;
  }
  .home-banner1-pic {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 315px;
  }
  .home-main {
    width: 1000px;
    margin: 0 auto;
    text-align: center;
  }
  .home-main-title {
    font-size: 32px;
    color: $primaryColor;
    padding-top: 70px;
    padding-bottom: 4px;
  }
  .home-main-spread {
    display: flex;
    flex-wrap: wrap;
    padding-top: 50px;
  }
  .home-main-spread-item {
    border-radius: 0 100px 0 40px;
    width: 20%;
    flex: 1;
    box-sizing: border-box;
    padding: 0 24px;
    margin: 0 22px;
    height: 305px;
    box-shadow: 0 0 13px rgba(0, 0, 0, 0.1);
    text-align: center;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      bottom: 8px;
      right: 8px;
      width: 23px;
      height: 23px;
      background: url('https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/youxiaojiao.png')
        no-repeat right bottom;
      background-size: 23px 23px;
    }
    img {
      width: 80px;
      padding-top: 37px;
    }
    h2 {
      font-size: 21px;
      font-weight: 500;
      color: $primaryColor;
      padding-top: 20px;
      padding-bottom: 16px;
    }
    p {
      text-align: left;
    }
  }
  .home-main-part-two {
    padding-top: 60px;
    padding-bottom: 20px;
    .app-shandian-button {
      margin: 0 auto;
      margin-top: 30px;
    }
  }
  .swiper-item-wrapper {
    &.gray {
      background-color: #fbfbfb;
    }
  }
  .swiper-item {
    width: 1000px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .pic {
      display: block;
    }
  }
  .e-commerce-swipe {
    .swiper-container {
      height: 518px;
      border-radius: 4px;
      box-shadow: 0 0 13px rgba(0, 0, 0, 0.1);
    }
  }
  .e-commerce-list {
    display: flex;
    justify-content: center;
    padding-top: 50px;
    padding-bottom: 30px;
  }
  .e-commerce-item {
    color: $primaryColor;
    font-size: 32px;
    padding-top: 60px;
    padding-bottom: 30px;
    text-align: center;
  }
  .e-commerce-intro-item {
    position: relative;
    padding-left: 36px;
    padding-bottom: 30px;
    text-align: left;
    h2 {
      color: $primaryColor;
      font-size: 18px;
      font-weight: 500;
    }
    p {
      padding-top: 8px;
    }
    &:last-child {
      padding-bottom: 0;
      &:before {
        display: none;
      }
    }
    &:before {
      content: '';
      width: 2px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 10px;
      background-color: #ffa800;
    }
    &:after {
      content: '';
      width: 18px;
      height: 18px;
      border: 2px solid #ffa800;
      background-color: #fff;
      position: absolute;
      border-radius: 50%;
      top: 0;
      left: 0;
    }
  }
  .home-contact-wrapper {
    display: flex;
    justify-content: center;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
  }
  .home-contact-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .home-contact {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
      0px 24px 38px 3px rgba(0, 0, 0, 0.14),
      0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  }
  .home-contact-title {
    text-align: center;
    padding-top: 40px;
    padding-bottom: 50px;
    font-size: 24px;
    font-weight: 500;
    color: $font-color-primary;
  }
  .home-contact-content {
    display: flex;
  }
  .home-contact-item {
    &--right {
      padding-left: 145px;
    }
    &--left {
      position: relative;
    }
    .error-text {
      position: absolute;
      top: 63px;
      font-size: 18px;
      left: 0;
    }
    h1 {
      font-size: 24px;
      color: $font-color-primary;
      font-weight: normal;
    }
    h2 {
      font-size: 18px;
      padding-top: 20px;
      font-weight: normal;
      color: $primaryColor;
    }
  }
  .home-contact-form {
    padding-top: 50px;
  }
  .home-contact-qr {
    text-align: center;
    img {
      padding-top: 50px;
      padding-bottom: 50px;
    }
  }
  .city-select-form-item {
    position: relative;
  }
  .city-select {
    position: absolute;
    top: 43px;
    left: 0;
    right: 0;
    display: flex;
  }
  .city-select-list {
    flex: 1;
    border-radius: 4px;
    min-width: 160px;
    background-color: #fff;
    max-height: 200px;
    overflow: auto;
    box-shadow: 1px 1px 13px rgba(0, 0, 0, 0.1);
  }
  .city-select-item {
    font-size: 14px;
    padding: 0 20px;
    height: 34px;
    line-height: 34px;
    box-sizing: border-box;
    &:hover,
    &.active {
      background-color: #f5f7fa;
    }
    &.active {
      color: $green;
    }
  }
  .error-text {
    color: $red;
  }
  .swiper-pagination {
    transition: none;
    .swiper-pagination-bullet {
      background-color: #f1f1f1;
      opacity: 1;
      margin: 0 8px;
      transition: all 250ms;
    }
    .swiper-pagination-bullet-active {
      background-color: $primaryColor;
      width: 44px;
      border-radius: 4.5px;
      transition-delay: 0s;
    }
  }
  .footer {
    text-align: center;
    margin-top: 90px;
    color: #fff;
    background: #363636
      url('https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/oss-move/visa-home/bg%403x.png')
      no-repeat right bottom;
    background-size: 100% auto;
    .home-main-title {
      color: #fff;
      padding-top: 50px;
    }
    .home-main-sub-title {
      color: #a5a5a5;
    }
  }
  .footer-function {
    display: flex;
    justify-content: center;
    padding-top: 80px;
    padding-bottom: 64px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }
  .footer-function-item {
    width: 290px;
    margin: 0 15px;
    .logo {
      display: inline-block;
      width: 104px;
      height: 104px;
      box-sizing: border-box;
      img {
        width: 100%;
      }
    }
    h3 {
      padding-top: 30px;
      padding-bottom: 16px;
      font-size: 21px;
      font-weight: 400;
    }
    p {
      font-size: 21px;
      font-weight: 400;
      color: #a5a5a5;
    }
  }
  .footer-intro {
    text-align: center;
    font-size: 21px;
    &-text {
      color: #a5a5a5;
      padding-top: 50px;
      padding-bottom: 24px;
    }
    &-button {
      display: inline-block;
      color: #fff;
      border: 1px solid #fff;
      border-radius: 20px;
      padding: 7px 35px;
      cursor: pointer;
    }
    &-tel {
      display: block;
      color: #fff;
      padding-top: 16px;
      padding-bottom: 54px;
    }
  }
}
@media screen and (max-width: 500px) {
  #shandian {
    .swiper-item-wrapper.gray {
      background: transparent;
    }
    .e-commerce-swipe {
      .swiper-container {
        width: 90%;
        margin: 0 auto;
      }
    }
    .swiper-wrapper {
      width: 100%;
    }
    .swiper-item {
      position: relative;
      overflow: hidden;
      width: auto;
      display: block;
      .pic {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 40%;
        z-index: 1;
      }
    }
    .e-commerce-intro {
      padding-top: 30px;
      padding-bottom: 140px;
      width: auto;
      position: relative;
      z-index: 2;
      background-color: transparent;
      padding-left: 10px;
      padding-right: 10px;
    }
    .e-commerce-item {
      padding: 7px 20px;
      font-size: 20px;
      margin: 0 10px;
    }
    .footer-function {
      display: block;
      padding-top: 34px;
      padding-bottom: 0;
    }
    .footer-function-item {
      width: auto;
      &:last-child {
        p {
          padding-bottom: 30px;
        }
      }
      .logo {
        width: 64px;
        height: 64px;
      }
      h3 {
        font-size: 16px;
        padding-top: 10px;
        padding-bottom: 5px;
      }
      p {
        font-size: 14px;
        padding-bottom: 50px;
        text-align: center !important;
      }
    }
    .footer-intro-text {
      padding-top: 20px;
      padding-bottom: 14px;
      font-size: 16px;
    }
    .footer-intro-button {
      font-size: 12px;
      padding: 4px 26px;
    }
    .footer-intro-tel {
      font-size: 14px;
      padding-bottom: 24px;
    }
    .home-main-spread {
      display: block;
    }
    .home-main-spread-item {
      width: auto;
      box-sizing: border-box;
      height: auto;
      margin-bottom: 20px;
      h2 {
        font-size: 16px;
        padding-top: 5px;
        padding-bottom: 5px;
      }
      img {
        width: 40px;
        padding-top: 10px;
      }
      p {
        padding-bottom: 10px;
      }
    }
    .home-main {
      width: auto;
    }
    .home-main-part-two {
      img {
        width: 100%;
      }
      .app-shandian-button {
        font-size: 12px;
        width: 60px;
        padding: 5px 10px;
      }
    }
    .app-header {
      position: static;
      height: 60px;
    }
    .app-header-nav {
      justify-content: center;
      max-width: auto;
      height: 60px;
    }
    .app-header-button {
      display: block;
    }
    .app-header-nav-box {
      display: none;
    }
    .home-banner-wrapper {
      margin-top: 0;
    }
    .home-arrow-line-left {
      border-width: 0 15px 15px 15px;
    }
    .home-arrow-line-right {
      border-width: 0 15px 15px 15px;
    }
    .home-intro-title {
      font-size: 28px;
    }
    .home-main-item {
      padding-bottom: 0;
    }
    .home-main-title {
      font-size: 24px;
      color: $primaryColor;
      padding-top: 30px;
    }
    .home-content-h5-wrap {
      padding-top: 15px;
      display: block;
      .home-content {
        display: block;
        margin-left: 30px;
      }
    }
    .home-content {
      display: none;
    }
    .home-feature-wrapper {
      display: block;
      padding: 0;
      padding-top: 25px;
    }
    .home-feature-background {
      display: none;
    }
    .home-feature-content {
      padding-bottom: 40px;
      background: none;
      box-shadow: none;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      position: static;
      .semi-circle {
        display: none;
      }
    }
    .home-feature-main-title {
      display: none;
      &.h5 {
        display: block;
        padding-top: 0;
        padding-bottom: 24px;
        font-size: 18px;
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -90px;
      }
    }
    .home-feature-list {
      width: 1120px;
      padding-top: 45px;
      .semi-circle {
        display: block;
        width: 20px;
        height: 20px;
        top: 60px;
        left: -10px;
        margin-top: 0;
        background-color: #cbf3f5;
        &:after {
          top: 0;
          width: 20px;
          height: 20px;
          left: -5px;
          margin-top: 0;
          background-color: #cbf3f5;
        }
      }
      .semi-circle-end {
        left: auto;
        right: -10px;
        &:after {
          left: auto;
          right: -5px;
        }
      }
    }
    .home-feature-item {
      background-color: #fff;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.06);
      border-radius: 6.4px;
      height: 291px;
      margin-left: 24px;
      &:after {
        display: none;
      }
      &:first-child {
        margin-left: 0;
      }
      img {
        padding-top: 24px;
      }
      .home-feature-title {
        padding-top: 16px;
        padding-bottom: 4px;
      }
      .home-content {
        display: block;
        font-size: 13px;
        padding-top: 6px;
      }
    }
    .home-intro {
      position: static;
      text-align: center;
    }
    .home-intro-icon {
      margin-top: 4px;
      justify-content: center;
    }
    .home-pic {
      float: none !important;
      padding: 0 30px;
      padding-top: 40px;
      img {
        width: 100%;
      }
    }
    .home-partner-title {
      font-size: 18px;
      padding-top: 50px;
      padding-bottom: 0;
    }
    .home-partner-sub-title {
      padding-top: 8px;
      padding-bottom: 40px;
      font-size: 14px;
    }
    .home-partner-list {
      display: none;
    }
    .home-partner-img {
      display: block;
      padding: 0 20px;
      padding-bottom: 50px;
      img {
        width: 100%;
      }
    }
    .home-contact-wrapper {
      display: block;
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 0;
    }
    .home-contact {
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 26px;
      width: 90%;
      box-sizing: border-box;
    }
    .home-contact-title {
      font-size: 18px;
      padding-top: 20px;
      padding-bottom: 8px;
    }
    .home-contact-content {
      display: block;
    }
    .home-contact-item {
      h1 {
        display: none;
      }
      h2 {
        font-size: 14px;
      }
      .home-contact-form {
        padding-top: 24px;
      }
      .home-contact-form-submit-button {
        display: flex;
        justify-content: center;
      }
      .error-text {
        font-size: 14px;
        top: 39px;
      }
    }
    .home-contact-qr {
      img {
        padding-top: 0;
        padding-bottom: 24px;
      }
      p {
        color: $primaryColor;
      }
      .dn {
        display: block;
      }
    }
    .home-contact-item--right {
      padding-left: 0;
      padding-top: 60px;
      h2 {
        display: none;
      }
    }
    .home-banner {
      height: auto;
    }
    .home-banner-item {
      display: none;
    }
    .home-banner-mobile {
      display: block;
      position: relative;
      .app-button {
        position: absolute;
        border-radius: 18px;
        padding-left: 32px;
        padding-right: 32px;
        bottom: 31%;
        left: 28%;
        margin-left: -60px;
        opacity: 0;
      }
    }
  }
  .app-footer {
    font-size: 12px;
    padding-top: 33px;
    padding-bottom: 16px;
  }
}
</style>
